import { NgModule } from '@angular/core';
import { addNavMenuItem, SharedModule } from '@vendure/admin-ui/core';

@NgModule({
    imports: [SharedModule],
    providers: [
        addNavMenuItem(
            {
                id: 'partners',
                label: 'Partners',
                routerLink: ['/extensions/partners'],
                icon: 'users',
            },
            'settings'
        ),
    ],
})
export class PartnersNavModule {}
